// extracted by mini-css-extract-plugin
export var arrows = "_6t-6";
export var decrementer = "_6t-a";
export var disabled = "_6t-4";
export var error = "_6t-1";
export var hiddenText = "_6t-b";
export var incrementer = "_6t-9";
export var input = "_6t-8";
export var inputWrapper = "_6t-0";
export var leadingIcon = "_6t-c";
export var readonly = "_6t-3";
export var regular = "_6t-7";
export var small = "_6t-5";
export var warning = "_6t-2";